import { isPromotionUser } from "../components/task/payment/planTypes";

/**
 * 광고/전환 추적(Meta CAPI·FB Pixel·Firebase·Appsflyer·Gtag·X Ads) 제외 대상 여부.
 *
 * Mixpanel 은 항상 이 가드 밖에서 호출되므로 영향받지 않는다.
 * 제외 대상:
 * - 인사이더(user.isInsider)
 * - 제휴 프로모션 사용자(user.promotion: 타이탄교육그룹 / 코리안매니아 등)
 */
export const isAdTrackingSuppressed = (
  user: { isInsider?: boolean; promotion?: string } | null | undefined
): boolean => user?.isInsider === true || isPromotionUser(user?.promotion);
